// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  heading: {
    marginBottom: 20,
  },
  button: {
    width: '100%',
    minWidth: 210,
    backgroundColor: theme.palette.ava.blue,
    color: theme.palette.ava.white,
  },
  buttonContained: {
    '&:hover': {
      backgroundColor: theme.palette.ava.blue,
    },
  },
  buttonLabel: {
    display: 'flex',
    flexDirection: 'column',
  },
  buttonMainText: {
    fontSize: 20,
    fontWeight: 600,
  },
  buttonSubText: {
    marginTop: -10,
    fontSize: 16,
    opacity: 0.8,
  },
}));

interface Props {
  onClick: Function;
}

const RatingPoor = ({ onClick }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.content}>
      <Typography className={classes.heading} variant="h5">
        {t('conversation.over.weAreSorryYouHadABadExperience')}
      </Typography>

      <Button
        key="download_convo_btn"
        classes={{
          root: classes.button,
          contained: classes.buttonContained,
          label: classes.buttonLabel,
        }}
        variant="contained"
        onClick={onClick}
      >
        <span className={classes.buttonMainText}>{t('conversation.over.sendFeedback')}</span>
      </Button>
    </div>
  );
};

export default RatingPoor;
